import {
  FcMiniFcWidgetButtonClasses,
  FinanceCalculatorTheme,
} from '@dxp-module/themes'
import { makeStyles } from '@mui/styles'

const miniFcWidgetButtonStyles = makeStyles<
  FinanceCalculatorTheme,
  object,
  FcMiniFcWidgetButtonClasses
>(
  ({ palette, typography }) => ({
    button: {
      color: palette.common.black,
      borderRadius: 0,
      padding: 0,
      width: 'fit-content',
    },
    selected: {
      backgroundColor: palette.secondary.main,
    },
    label: {
      textTransform: 'uppercase',
      flexGrow: 0,
    },
    arrowIcon: {
      transition: 'transform 0.2s linear',
      flexGrow: 0,
    },
    arrowUp: {
      transform: 'rotate(-180deg)',
    },
    calculatorIcon: {
      flexGrow: 0,
      // TODO fix guidance linting error forbidden-style-keys
      // eslint-disable-next-line @dxp-module/guidance/forbidden-style-keys
      fontSize: typography.fontLG,
    },
    cash: {
      flexGrow: 1,
    },
    repayment: {
      flexGrow: 1,
      paddingLeft: '10px',
      paddingTop: '5px',
      textAlign: 'left',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
    repaymentAmount: {
      color: 'inherit',
      fontWeight: 600,
      lineHeight: 0.8,
    },
    repaymentFrequency: {
      fontWeight: 400,
      color: 'inherit',
      textTransform: 'uppercase',
    },
    reffineButton: {},
    iprButton: {},
  }),
  { name: 'MiniFC_Button' }
)

export default miniFcWidgetButtonStyles
